/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit'
import * as Services from '../../services/endpoints'
import { RunQueueResult, SearchJobsBody } from '../../pages/JobQueue/types'
import { createGenericSlice, GenericState } from '../lib'
import { Job } from '../../types'

const sliceName = 'jobs'

//todo need to reverse this and use the sate as the type
export interface JobState extends GenericState<Job> {}

export const getAllJobs = createAsyncThunk(
  `${sliceName}/getAllJobs`,
  async (
    query: {
      [k: string]: string | number
    } = {},
    { rejectWithValue }
  ) => {
    try {
      return await Services.getAllJobs(query)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const getJob = createAsyncThunk(
  `${sliceName}/getJob`,
  async (id: string, { rejectWithValue }) => {
    try {
      return await Services.getJob(id)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const createJob = createAsyncThunk(
  `${sliceName}/createJob`,
  async (id: string, { rejectWithValue }) => {
    try {
      return await Services.createJob(id)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const cancelJobs = createAsyncThunk(
  `${sliceName}/cancelJobs`,
  async (ids: string[], { rejectWithValue }) => {
    try {
      return await Services.cancelJobs(ids)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const searchJobs = createAsyncThunk(
  `${sliceName}/searchJobs`,
  async (body: SearchJobsBody, { rejectWithValue }) => {
    try {
      return await Services.searchJobs(body)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const removeJobs = createAsyncThunk(
  `${sliceName}/removeJobs`,
  async (ids: string[], { rejectWithValue }) => {
    try {
      return await Services.removeJobs(ids)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const jobsAdapter = createEntityAdapter<RunQueueResult>()

//TODO fix type issue and replace any
const thunkAdapters: any = [
  {
    adapterFn: jobsAdapter.setAll,
    thunk: getAllJobs,
  },
  {
    adapterFn: jobsAdapter.upsertOne,
    thunk: getJob,
  },
  {
    adapterFn: jobsAdapter.addOne,
    thunk: createJob,
  },
  {
    adapterFn: jobsAdapter.upsertMany,
    thunk: cancelJobs,
  },
  {
    adapterFn: jobsAdapter.setAll,
    thunk: searchJobs,
  },
  {
    adapterFn: jobsAdapter.removeMany,
    thunk: removeJobs,
  },
]

export const initialJobsState: JobState = {
  loading: false,
  error: null,
  ids: [],
  entities: {},
}

export const jobsSlice = createGenericSlice({
  name: sliceName,
  initialState: initialJobsState,
  thunkAdapters,
})
